import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as authActions from "../../action/authActions";
import whitelogo from "../../images/new_logo.png";
import pexelsphoto from "../../images/Platform_Banner.jpg";
import eye from "../../images/eye.svg";
import "./loginmain.css";

let Signin = (props) => {
  const [formData, setName] = useState({ username: "", Upassword: "" });
  const [passwordShown, setPasswordShown] = useState(false);
  const [loading, setLoading] = useState(false);

  const Loginsubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    authActions.login(
      formData.username,
      formData.Upassword,
      setLoading
    );
  };


  const handleChange = (e) => {
    setName({ ...formData, [e.target.name]: e.target.value });
  };

  const togglePassword = () => {
    setPasswordShown(!passwordShown);
  };

  return (
    <section className="ftco-section">
      <div class="logo">
        <img src={whitelogo} style={{ width: "200px", marginTop: "2em" }} />
      </div>
      <div className="container-fliud">
        <div className="row align-items-center">
          <div className="col-md-6 px-0">
            <div className="login-wrap">
              <form
                action="#"
                className="signin-form custom-form"
                onSubmit={Loginsubmit}
              >
                <div className="form-group mb-3">
                  <div className="icon d-flex align-items-center justify-content-center">
                  </div>
                  <input
                    type="text"
                    className="form-control"
                    name="username"
                    value={formData.username}
                    placeholder="username"
                    onChange={handleChange}
                    id="username"
                    required
                  />
                </div>
                <div className="form-group mb-3">
                  <div className="icon d-flex align-items-center justify-content-center">
                  </div>
                  <input
                    id="password-field"
                    type={passwordShown ? "text" : "password"}
                    name="Upassword"
                    className="form-control"
                    placeholder="Password "
                    value={formData.Upassword}
                    onChange={handleChange}
                    required />
                  <img
                    src={eye}
                    className="toggle-password"
                    onClick={togglePassword}
                    alt=""
                  />
                  {/* <span toggle="#password-field" className="fa fa-fw fa-eye field-icon toggle-password"></span> */}
                </div>
                <div className="form-check mb-3">
                  <label className="form-check-label" for="form2Example31">
                    {/* <input className="form-check-input me-2" type="checkbox" value="" id="form2Example31" checked="" /> Keep Me Logged In </label> */}
                    <input
                      type="checkbox"
                      className="form-check-input me-2"
                    />
                    Remember Me
                  </label>
                </div>
                <div className="mb-2">
                  <button
                    type="submit"
                    disabled={loading}
                    style={{ lineHeight: "30px", backgroundColor: "#15bd8c", color: "#FFF", opacity: loading ? 0.7 : 1 }}
                    className="form-control submit px-3"
                  >
                    {loading ? (
                      <>
                        <span className="spinner-border spinner-border-sm me-2"></span>
                        LOGGING IN...
                      </>
                    ) : (
                      "LOG IN"
                    )}
                  </button>
                </div>
              </form>
            </div>
            <div
              style={{
                maxWidth: "370px",
                margin: "20px auto",
                textAlign: "center",
              }}
            >
              <p>
                Create Your Own Cases With AI-Enabled Virtual Humans
              </p>
            </div>
          </div>
          <div className="col-md-6 px-0 right-im-box">
            <img className="" src={pexelsphoto} />
          </div>
        </div>
      </div>
    </section>
  );
  // }else{
  //   return (<Redirect to="/"></Redirect>)
  // }
};
const mapStateToProps = (state) => {
  return {
    auth: state.auth,
    companyDefaults: state.companyDefaults,
  };
};

const mapDispatchToProps = (dispatch) => {
  return { authActions: bindActionCreators(authActions, dispatch) };
};

export default connect(mapStateToProps, mapDispatchToProps)(Signin);
